export default __webpack_public_path__ + "static/media/5.4a6b39bf.svg";